// extracted by mini-css-extract-plugin
export default {"underlinedText":"style--underlinedText--d35e8f"};